import { getTokenFromCookie } from "@/utils/permissions";
import CpCommunityConsole from "@/components/communityPortal/community/CpCommunityConsole";
import NotFound from "@/components/common/NotFound";
import CpHome from "@/components/communityPortal/home/CpHome";
import { isCommunityPortal } from "@/utils/type";

function CommunityConsole({ type, loggedIn }) {
    if (!isCommunityPortal(type)) {
        return <NotFound />;
    }

    if (loggedIn) {
        return <CpCommunityConsole />;
    } else {
        return <CpHome />;
    }
}

export const getServerSideProps = async (context) => {
    const token = await getTokenFromCookie(context.req.cookies);

    if (token === undefined) {
        return {
            props: {
                loggedIn: false,
                type: process.env.NEXT_PUBLIC_TYPE,
            },
        };
    }

    // we need to verify the token to check if it is ok, and then set the loggedIn below.

    return {
        props: {
            loggedIn: true,
            type: process.env.NEXT_PUBLIC_TYPE,
        },
    };
};

export default CommunityConsole;
